'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _components = require('../../components');
var _publish = require('../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);
var _PublishPropertyForm = require('../../containers/PublishForm/PublishPropertyForm.scss');var styles = _interopRequireWildcard(_PublishPropertyForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PriceBlock = function (_Component) {_inherits(PriceBlock, _Component);function PriceBlock() {var _temp, _this, _ret;_classCallCheck(this, PriceBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.



































    getPlaceholder = function () {
      if (_this.props.fields.search_option === 'rent') {
        return _this.props.rentOption === 'rent-short' ? 'daily_payment' : 'monthly_payment';
      }
      return 'price';
    }, _this.

    fieldsHandler = function (initialValues, value) {return Object.keys((0, _omit2.default)(initialValues, value)).
      forEach(function (field) {return _this.props.changeValue('entry_date.' + field, initialValues[field]);});}, _this.

    renderInput = function (_ref) {var input = _ref.input,meta = _ref.meta;
      var placeholder = input.name === 'payments.rental' ? 'number_of_payments' : _this.placeholder;
      return _react2.default.createElement('input', _extends({},
      input, {
        type: 'text',
        placeholder: _this.props.translate(placeholder),
        className: (0, _classnames2.default)(styles.numeric, styles.inputPrice, styles.inputNumb, 'form-control',
        { not_valid: meta.touched && meta.error && !meta.active }) }));

    }, _this.

    renderCheckbox = function (field) {return _react2.default.createElement('div', null,
        _react2.default.createElement(_reduxForm.Field, {
          name: 'entry_date.' + field,
          props: { locale: _this.props.locale },
          component: function component(_ref2) {var input = _ref2.input;return (
              _react2.default.createElement(_components.OMCheckbox, { id: field, field: Object.assign({}, input, { checked: input.value }), label: '' + _this.props.translate(field) }));} }));}, _temp), _possibleConstructorReturn(_this, _ret);}PriceBlock.prototype.componentDidMount = function componentDidMount() {var entryDate = this.props.fields.entry_date;var date = entryDate ? entryDate.date : null;this.props.registerNewField('entry_date');this.props.changeValue('entry_date.date', date);};PriceBlock.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {var fields = _ref3.fields;var entryDate = this.props.fields.entry_date;if (entryDate && fields.entry_date) {var initialValues = { date: null, immediate: false, flexible: false };if (!entryDate.date && fields.entry_date.date) {this.fieldsHandler(initialValues, 'date');}if (!entryDate.immediate && fields.entry_date.immediate) {this.fieldsHandler(initialValues, 'immediate');}if (!entryDate.flexible && fields.entry_date.flexible) {this.fieldsHandler(initialValues, 'flexible');}}};PriceBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref4) {var fields = _ref4.fields,locale = _ref4.locale,config = _ref4.config;var fieldsChanged = !(0, _isEqual2.default)(this.props.fields, fields);var configChanged = !(0, _isEqual2.default)(this.props.config, config);var localeChanged = this.props.locale !== locale;return fieldsChanged || localeChanged || configChanged;};PriceBlock.prototype.




  renderEntryDate = function renderEntryDate() {var _this2 = this;var
    entryDate = this.props.fields.entry_date;
    return (
      _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
        _react2.default.createElement('span', { className: 'label' }, this.props.translate('evictionDate')),
        _react2.default.createElement('div', { className: 'fieldset' },
          _react2.default.createElement(_components.OMDatePicker, {
            isReadOnly: true,
            className: styles.fieldDate,
            locale: this.props.locale,
            value: entryDate && entryDate.date,
            onSelect: function onSelect(selectedValue) {return _this2.props.changeValue('entry_date.date', selectedValue);},
            dayLabels: this.props.datePickerTranslates('DayLabels').split(','),
            monthLabels: this.props.datePickerTranslates('MonthLabels').split(',') }),

          _react2.default.createElement('div', { className: styles.dateRadioButtons },
            this.renderCheckbox('immediate'),
            this.renderCheckbox('flexible')))));




  };PriceBlock.prototype.

  renderPaymentsPerYear = function renderPaymentsPerYear() {
    return (
      _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
        _react2.default.createElement('span', { className: 'label' }, this.props.translate('number_of_payments')),
        _react2.default.createElement('div', { className: 'fieldset' },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'payments.rental',
            props: { locale: this.props.locale },
            component: this.renderInput,
            normalize: _publish2.default.rental }))));




  };PriceBlock.prototype.

  render = function render() {var _props$config =
    this.props.config,price = _props$config.price,entryDate = _props$config.entryDate,paymentsPerYear = _props$config.paymentsPerYear,currency = _props$config.currency;
    this.placeholder = this.getPlaceholder();
    return (
      _react2.default.createElement(_reactScroll.Element, { name: 'priceAndCondition', className: styles.sectionBlock },
        _react2.default.createElement('div', { className: styles.title }, this.props.translate('sections', 'priceAndDealDetails')),

        price &&
        _react2.default.createElement(_reactScroll.Element, { name: 'price' },
          _react2.default.createElement(_components.OMPriceInput, {
            field: 'price',
            locale: this.props.locale,
            placeholder: '' + this.props.translate(this.placeholder),
            isRequired: true,
            isMobile: this.props.isMobile,
            isForeign: this.props.isForeign,
            currency: currency,
            translate: this.props.translate })),




        paymentsPerYear && this.renderPaymentsPerYear(),

        entryDate && this.renderEntryDate()));



  };return PriceBlock;}(_react.Component);exports.default = PriceBlock;


PriceBlock.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  datePickerTranslates: _propTypes2.default.func.isRequired,
  config: _propTypes2.default.object.isRequired,
  changeValue: _propTypes2.default.func.isRequired,
  registerNewField: _propTypes2.default.func.isRequired,
  locale: _propTypes2.default.string.isRequired,
  fields: _propTypes2.default.object.isRequired,
  isMobile: _propTypes2.default.bool,
  rentOption: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PriceBlock/PriceBlock.js
// module id = 2799
// module chunks = 0